import { Code2, Layers, LayoutDashboard, LineChart, MessageSquare } from 'lucide-react';
import { AppSidebar } from '@/components/AppSidebar';
import { useTrainerQuestionInbox } from '@/lib/hooks/useTopicMessages';

export function TrainerSidebar() {
  const { data: threads = [] } = useTrainerQuestionInbox(true);
  const needsReply = threads.filter((t) => t.last_sender_id === t.student_id).length;

  const navGroups = [
    {
      label: '',
      items: [
        { to: '/trainer/dashboard', label: 'Dashboard', icon: <LayoutDashboard className="h-[18px] w-[18px]" /> },
        { to: '/trainer/batches', label: 'Batches', icon: <Layers className="h-[18px] w-[18px]" /> },
        { to: '/trainer/problems', label: 'Problems', icon: <Code2 className="h-[18px] w-[18px]" /> },
        { to: '/trainer/questions', label: 'Questions', icon: <MessageSquare className="h-[18px] w-[18px]" />, badge: needsReply },
        { to: '/trainer/analytics', label: 'Analytics', icon: <LineChart className="h-[18px] w-[18px]" /> },
      ],
    },
  ];

  return (
    <AppSidebar
      navGroups={navGroups}
      storageKey="trainer-sidebar-collapsed"
      settingsPath="/trainer/settings"
      autoCollapsePattern={/^\/trainer\/batches\/[^/]+\/curriculum/}
    />
  );
}
